export const WALLBOARD_GAUGE_CONFIG = {
  GAUGE_SIZE: 46,
  MAX_SCHEDULE_DAYS: 12,
};

export const WALLBOARD_TILE_LAYOUT = {
  BOTTOM_SECTION_HEIGHT_RATIO: 0.4268,
  TIMELINE_LINE_HEIGHT_RATIO: 0.0175,
  GAUGE_ROW_HEIGHT_PERCENT: '14.04%',
  NC_FILE_AREA_HEIGHT_RATIO: 0.4328,
  NC_FILE_VISIBLE_LINES: 10,
  NC_FILE_LINE_HEIGHT_TO_FONT_SIZE_RATIO: 1.5,
  NC_FILE_LETTER_SPACING_RATIO: 0.02,
  NC_FILE_PADDING_TOP_RATIO: 0.03,
};

export const WALLBOARD_STATUS_CHANGE = {
  DISPLAY_DURATION: 3000,
  FADE_DURATION: 300,
};

export const WALLBOARD_PROGRESS_BAR = {
  HEIGHT_PERCENT: '18.12%',
  PADDING_HORIZONTAL_PERCENT: '3.93%',
  PADDING_TOP_PERCENT: '3.93%',
  HOUR_LENGTH_RATIO: 0.2362,
};

export const WALLBOARD_LEVELS = [
  { text: 'Live', value: 'live' },
  { text: '24h', value: 'last24' },
  { text: 'Day', value: 'today' },
] as const;

export const WALLBOARD_DATE_AT_MIDNIGHT_CHECK_INTERVAL_MS = 5000;